import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useAppSelector } from '../../redux/store';
import { FRIENDS_PANEL_CONTENT_COLOR } from '../../styles/colors';
import { FramelessPanelSection } from '../framelessPanelSection';
import { FriendsPanelContents } from './friendsPanelContents';
export const FriendsPanelContentsContainer = () => {
    // TODO: Improve this inefficient selector:
    const activeContacts = useAppSelector((state) => state.contacts.activeContacts);
    if (!activeContacts) {
        // likely still fetching
        return null;
    }
    return (_jsx(FramelessPanelSection, { "aria-label": 'friends list', backgroundColor: FRIENDS_PANEL_CONTENT_COLOR, children: _jsx(FriendsPanelContents, { activeContacts: activeContacts }) }));
};
